import { ItemId, RecipeId, FacilityId } from "@/types/constants";
import type { Recipe } from "@/types";

export const recipes: Recipe[] = [
  {
    id: RecipeId.COMPONENT_ACTIVITY_XIRANITE_CMPT_1,
    inputs: [{ itemId: ItemId.ITEM_XIRANITE_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_ACTIVITY_XIRANITE_CMPT, amount: 1 }],
    facilityId: FacilityId.COMPONENT_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.COMPONENT_ACTIVITY_XIRANITE_ENR_CMPT_1,
    inputs: [{ itemId: ItemId.ITEM_XIRANITE_ENR_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_CMPT, amount: 2 }],
    facilityId: FacilityId.COMPONENT_MC_1,
    craftingTime: 20,
  },
  {
    id: RecipeId.COMPONENT_COPPER_CMPT_1,
    inputs: [{ itemId: ItemId.ITEM_COPPER_NUGGET, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_COPPER_CMPT, amount: 1 }],
    facilityId: FacilityId.COMPONENT_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.COMPONENT_COPPER_ENR_CMPT_1,
    inputs: [{ itemId: ItemId.ITEM_COPPER_ENR, amount: 5 }],
    outputs: [{ itemId: ItemId.ITEM_COPPER_ENR_CMPT, amount: 1 }],
    facilityId: FacilityId.COMPONENT_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.COMPONENT_GLASS_CMPT_1,
    inputs: [{ itemId: ItemId.ITEM_QUARTZ_GLASS, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_GLASS_CMPT, amount: 1 }],
    facilityId: FacilityId.COMPONENT_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.COMPONENT_GLASS_ENR_CMPT_1,
    inputs: [{ itemId: ItemId.ITEM_QUARTZ_ENR, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_GLASS_ENR_CMPT, amount: 1 }],
    facilityId: FacilityId.COMPONENT_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.COMPONENT_IRON_CMPT_1,
    inputs: [{ itemId: ItemId.ITEM_IRON_NUGGET, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_IRON_CMPT, amount: 1 }],
    facilityId: FacilityId.COMPONENT_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.COMPONENT_IRON_ENR_CMPT_1,
    inputs: [{ itemId: ItemId.ITEM_IRON_ENR, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_IRON_ENR_CMPT, amount: 1 }],
    facilityId: FacilityId.COMPONENT_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_ACID_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_ACID, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_COPPER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_COPPER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_COPPER_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_COPPER_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_GRASS_1_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_GRASS_1, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_GRASS_2_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_GRASS_2, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_SEWAGE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_SEWAGE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_WATER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_WATER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_XIRANITE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_XIRANITE_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_XIRANITE_LOWPOLY_1,
    inputs: [
      { itemId: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPER_XIRANITE_POLY_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE_POLY, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_ACID_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_ACID, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_COPPER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_COPPER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_COPPER_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_COPPER_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_GRASS_1_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_GRASS_1, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_GRASS_2_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_GRASS_2, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_SEWAGE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_SEWAGE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_WATER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_WATER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_XIRANITE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_XIRANITE_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_XIRANITE_LOWPOLY_1,
    inputs: [
      { itemId: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_COPPERENR_XIRANITE_POLY_1,
    inputs: [
      { itemId: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE_POLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_ACID_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_ACID, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_COPPER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_COPPER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_COPPER_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_COPPER_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_GRASS_1_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_GRASS_1, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_GRASS_2_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_GRASS_2, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_SEWAGE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_SEWAGE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_WATER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_WATER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_XIRANITE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_XIRANITE_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_XIRANITE_LOWPOLY_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE_LOWPOLY, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASS_XIRANITE_POLY_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE_POLY, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_ACID_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_ACID, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_COPPER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_COPPER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_COPPER_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_COPPER_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_GRASS_1_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_GRASS_1, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_GRASS_2_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_GRASS_2, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_SEWAGE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_SEWAGE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_WATER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_WATER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_XIRANITE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_XIRANITE_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_XIRANITE_LOWPOLY_1,
    inputs: [
      { itemId: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_GLASSENR_XIRANITE_POLY_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE_POLY, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_ACID_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_ACID, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_COPPER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_COPPER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_COPPER_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_COPPER_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_GRASS_1_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_GRASS_1, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_GRASS_2_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_GRASS_2, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_SEWAGE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_SEWAGE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_WATER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_WATER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_XIRANITE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_XIRANITE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_XIRANITE_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_XIRANITE_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_XIRANITE_LOWPOLY_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_XIRANITE_LOWPOLY, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRON_XIRANITE_POLY_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_XIRANITE_POLY, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_ACID_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_ACID, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_COPPER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_COPPER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_COPPER_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_COPPER_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_GRASS_1_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_GRASS_1, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_GRASS_2_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_GRASS_2, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_SEWAGE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_SEWAGE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_WATER_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_WATER, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_XIRANITE_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_XIRANITE_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE_ENR, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_XIRANITE_LOWPOLY_1,
    inputs: [
      { itemId: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_IRONENR_XIRANITE_POLY_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE_POLY, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.DISMANTLER_XIRANENR_GRASS_2_1,
    inputs: [{ itemId: ItemId.ITEM_FBOTTLE_XIRANENR_GRASS_2, amount: 1 }],
    outputs: [
      { itemId: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 5 },
    ],
    facilityId: FacilityId.DISMANTLER_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_ACID,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_ACID, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_COPPER,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_COPPER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_COPPER_ENR,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_COPPER_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_GRASS_1,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_GRASS_1, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_GRASS_2,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_GRASS_2, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_SEWAGE,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_SEWAGE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_WATER,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_WATER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_XIRANITE,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_XIRANITE_ENR,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_XIRANITE_LOWPOLY,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPER_XIRANITE_POLY,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPER_XIRANITE_POLY, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_ACID,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_ACID, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_COPPER,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_COPPER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_COPPER_ENR,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_COPPER_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_GRASS_1,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_GRASS_1, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_GRASS_2,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_GRASS_2, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_SEWAGE,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_SEWAGE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_WATER,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_WATER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_XIRANITE,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_XIRANITE_ENR,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE_ENR, amount: 1 },
    ],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_XIRANITE_LOWPOLY,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_COPPERENR_XIRANITE_POLY,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_FBOTTLE_COPPERENR_XIRANITE_POLY, amount: 1 },
    ],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_FOOD_1_1,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 5 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_2, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_FOOD_1, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.FILLING_BOTTLED_FOOD_2_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 10 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_2, amount: 10 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_FOOD_2, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.FILLING_BOTTLED_FOOD_3_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 10 },
      { itemId: ItemId.ITEM_PLANT_MOSS_ENR_POWDER_2, amount: 10 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_FOOD_3, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_ACID,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_ACID, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_COPPER,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_COPPER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_COPPER_ENR,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_COPPER_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_GRASS_1,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_GRASS_1, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_GRASS_2,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_GRASS_2, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_SEWAGE,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_SEWAGE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_WATER,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_WATER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_XIRANITE,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_XIRANITE_ENR,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_XIRANITE_LOWPOLY,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASS_XIRANITE_POLY,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASS_XIRANITE_POLY, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_ACID,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_ACID, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_COPPER,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_COPPER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_COPPER_ENR,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_COPPER_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_GRASS_1,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_GRASS_1, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_GRASS_2,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_GRASS_2, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_SEWAGE,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_SEWAGE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_WATER,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_WATER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_XIRANITE,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_XIRANITE_ENR,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_XIRANITE_LOWPOLY,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_GLASSENR_XIRANITE_POLY,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_FBOTTLE_GLASSENR_XIRANITE_POLY, amount: 1 },
    ],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_ACID,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_ACID, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_COPPER,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_COPPER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_COPPER_ENR,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_COPPER_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_GRASS_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_GRASS_1, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_GRASS_2,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_GRASS_2, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_SEWAGE,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_SEWAGE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_WATER,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_WATER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_XIRANITE,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_XIRANITE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_XIRANITE_ENR,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_XIRANITE_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_XIRANITE_LOWPOLY,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_XIRANITE_LOWPOLY, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRON_XIRANITE_POLY,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRON_XIRANITE_POLY, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_ACID,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_ACID, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_COPPER,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_COPPER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_COPPER_ENR,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_COPPER_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_GRASS_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_GRASS_1, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_GRASS_2,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_GRASS_2, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_SEWAGE,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_SEWAGE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_WATER,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_WATER, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_XIRANITE,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_XIRANITE_ENR,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE_ENR, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_XIRANITE_LOWPOLY,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_IRONENR_XIRANITE_POLY,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_IRONENR_XIRANITE_POLY, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FILLING_BOTTLED_REC_HP_1_1,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 5 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_1, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_REC_HP_1, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.FILLING_BOTTLED_REC_HP_2_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_BOTTLE, amount: 10 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_1, amount: 10 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_REC_HP_2, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.FILLING_BOTTLED_REC_HP_3_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 10 },
      { itemId: ItemId.ITEM_PLANT_MOSS_ENR_POWDER_1, amount: 10 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_REC_HP_3, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.FILLING_BOTTLED_XIRANENR_GRASS_2,
    inputs: [
      { itemId: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_BOTTLE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_FBOTTLE_XIRANENR_GRASS_2, amount: 1 }],
    facilityId: FacilityId.FILLING_POWDER_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.FLUID_CONSUME_LIQUID_CLEANER_1_ITEM_LIQUID_SEWAGE,
    inputs: [{ itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 }],
    outputs: [],
    facilityId: FacilityId.LIQUID_CLEANER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FLUID_CONSUME_LIQUID_CLEANER_1_ITEM_LIQUID_XIRANITE_LOWPOLY,
    inputs: [{ itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 }],
    outputs: [],
    facilityId: FacilityId.LIQUID_CLEANER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FLUID_CONSUME_LIQUID_CLEANER_1_ITEM_LIQUID_XIRANITE_POLY,
    inputs: [{ itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 }],
    outputs: [],
    facilityId: FacilityId.LIQUID_CLEANER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_CARBON_ENR_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_ENR, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_ENR_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_ENR_POWDER_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_ENR_POWDER, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_ENR_POWDER_2,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_ENR_POWDER_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_ENR_POWDER, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_MATERIAL_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_MTL, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_MATERIAL_2,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_MTL, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_MATERIAL_3,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_3, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_MTL, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_MATERIAL_4,
    inputs: [{ itemId: ItemId.ITEM_PLANT_TUNDRA_WOOD, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_MTL, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_MATERIAL_5,
    inputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_MTL, amount: 2 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_MATERIAL_6,
    inputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_MTL, amount: 2 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_POWDER_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_POWDER, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_POWDER_2,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_POWDER_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_POWDER, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_POWDER_3,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_POWDER_3, amount: 3 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_POWDER, amount: 2 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_POWDER_4,
    inputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_POWDER_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_POWDER, amount: 2 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CARBON_POWDER_5,
    inputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_POWDER_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_POWDER, amount: 2 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_COPPER_NUGGET_1,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ORE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_NUGGET, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CRYSTAL_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_CRYSTAL_ENR_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CRYSTAL_ENR, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CRYSTAL_ENR_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_ORIGINIUM_ENR_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CRYSTAL_ENR_POWDER, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CRYSTAL_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_ORIGINIUM_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CRYSTAL_POWDER, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CRYSTAL_SHELL_1,
    inputs: [{ itemId: ItemId.ITEM_ORIGINIUM_ORE, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CRYSTAL_SHELL, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_CRYSTAL_SHELL_2,
    inputs: [{ itemId: ItemId.ITEM_CRYSTAL_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CRYSTAL_SHELL, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_IRON_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_IRON_ENR_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_IRON_ENR, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_IRON_NUGGET_1,
    inputs: [{ itemId: ItemId.ITEM_IRON_ORE, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_IRON_NUGGET, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_IRON_NUGGET_2,
    inputs: [{ itemId: ItemId.ITEM_IRON_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_IRON_NUGGET, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_QUARTZ_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_QUARTZ_ENR_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_QUARTZ_ENR, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_QUARTZ_GLASS_1,
    inputs: [{ itemId: ItemId.ITEM_QUARTZ_SAND, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_QUARTZ_GLASS, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.FURNANCE_QUARTZ_GLASS_2,
    inputs: [{ itemId: ItemId.ITEM_QUARTZ_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_QUARTZ_GLASS, amount: 1 }],
    facilityId: FacilityId.FURNANCE_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_CARBON_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_CARBON_MTL, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CARBON_POWDER, amount: 2 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_COPPER_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_COPPER_NUGGET, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_COPPER_POWDER, amount: 1 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_CRYSTAL_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_CRYSTAL_SHELL, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_CRYSTAL_POWDER, amount: 1 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_IRON_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_IRON_NUGGET, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_IRON_POWDER, amount: 1 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_ORIGINIUM_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_ORIGINIUM_ORE, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_ORIGINIUM_POWDER, amount: 1 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_PLANT_BBFLOWER_POWDER_1_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_BBFLOWER_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_BBFLOWER_POWDER_1, amount: 2 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_PLANT_GRASS_POWDER_1_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_POWDER_1, amount: 2 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_PLANT_GRASS_POWDER_2_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_POWDER_2, amount: 2 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_PLANT_MOSS_POWDER_1_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_POWDER_1, amount: 2 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_PLANT_MOSS_POWDER_2_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_POWDER_2, amount: 2 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_PLANT_MOSS_POWDER_3_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_3, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_POWDER_3, amount: 3 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.GRINDER_QUARTZ_POWDER_1,
    inputs: [{ itemId: ItemId.ITEM_QUARTZ_GLASS, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_QUARTZ_POWDER, amount: 1 }],
    facilityId: FacilityId.GRINDER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.LIQUID_PURIFIER_COPPER_ENR_1,
    inputs: [{ itemId: ItemId.ITEM_LIQUID_COPPER, amount: 4 }],
    outputs: [
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    facilityId: FacilityId.LIQUID_PURIFIER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.LIQUID_PURIFIER_XIRANITE_POLY_1,
    inputs: [{ itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 4 }],
    outputs: [
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    facilityId: FacilityId.LIQUID_PURIFIER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.PLANTER_PLANT_BBFLOWER_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_BBFLOWER_SEED_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_BBFLOWER_1, amount: 1 }],
    facilityId: FacilityId.PLANTER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.PLANTER_PLANT_GRASS_1_1,
    inputs: [
      { itemId: ItemId.ITEM_PLANT_GRASS_SEED_1, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_1, amount: 2 }],
    facilityId: FacilityId.PLANTER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.PLANTER_PLANT_GRASS_2_1,
    inputs: [
      { itemId: ItemId.ITEM_PLANT_GRASS_SEED_2, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_2, amount: 2 }],
    facilityId: FacilityId.PLANTER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.PLANTER_PLANT_MOSS_1_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_SEED_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_1, amount: 1 }],
    facilityId: FacilityId.PLANTER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.PLANTER_PLANT_MOSS_2_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_SEED_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_2, amount: 1 }],
    facilityId: FacilityId.PLANTER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.PLANTER_PLANT_MOSS_3_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_SEED_3, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_3, amount: 1 }],
    facilityId: FacilityId.PLANTER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_COPPER_ENR_1,
    inputs: [
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 2 },
      { itemId: ItemId.ITEM_IRON_POWDER, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.MIX_POOL_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_COPPER_ENR_2,
    inputs: [
      { itemId: ItemId.ITEM_LIQUID_COPPER_ENR, amount: 2 },
      { itemId: ItemId.ITEM_IRON_POWDER, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_COPPER_ENR, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.MIX_POOL_2,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_COPPER_1,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_POWDER, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_COPPER_2,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_POWDER, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_COPPER, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_2,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_LIQUID_XIRANITE_1,
    inputs: [
      { itemId: ItemId.ITEM_XIRANITE_POWDER, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_LIQUID_XIRANITE_2,
    inputs: [
      { itemId: ItemId.ITEM_XIRANITE_POWDER, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_2,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_PLANT_GRASS_1_1,
    inputs: [
      { itemId: ItemId.ITEM_PLANT_GRASS_POWDER_1, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_PLANT_GRASS_1_2,
    inputs: [
      { itemId: ItemId.ITEM_PLANT_GRASS_POWDER_1, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_1, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_2,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_PLANT_GRASS_2_1,
    inputs: [
      { itemId: ItemId.ITEM_PLANT_GRASS_POWDER_2, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_PLANT_GRASS_2_2,
    inputs: [
      { itemId: ItemId.ITEM_PLANT_GRASS_POWDER_2, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_PLANT_GRASS_2, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_2,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_XIRANITE_ENR_1,
    inputs: [
      { itemId: ItemId.ITEM_XIRANITE_ENR_POWDER, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_XIRANITE_ENR_2,
    inputs: [
      { itemId: ItemId.ITEM_XIRANITE_ENR_POWDER, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_ACID, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_LIQUID_XIRANITE_ENR, amount: 1 }],
    facilityId: FacilityId.MIX_POOL_2,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_XIRANITE_POLY_1,
    inputs: [
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.MIX_POOL_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_LIQUID_XIRANITE_POLY_2,
    inputs: [
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_LOWPOLY, amount: 1 },
    ],
    facilityId: FacilityId.MIX_POOL_2,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_XIRANITE_POLY_1,
    inputs: [
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 2 },
      { itemId: ItemId.ITEM_IRON_POWDER, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_XIRANITE_POLY, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.MIX_POOL_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.POOL_XIRANITE_POLY_2,
    inputs: [
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 2 },
      { itemId: ItemId.ITEM_IRON_POWDER, amount: 1 },
    ],
    outputs: [
      { itemId: ItemId.ITEM_XIRANITE_POLY, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_SEWAGE, amount: 1 },
    ],
    facilityId: FacilityId.MIX_POOL_2,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_BBFLOWER_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_BBFLOWER_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_BBFLOWER_SEED_1, amount: 2 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_GRASS_1_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_SEED_1, amount: 1 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_GRASS_2_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_GRASS_SEED_2, amount: 1 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_MOSS_1_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_SEED_1, amount: 2 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_MOSS_2_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_SEED_2, amount: 2 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_MOSS_3_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_3, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_SEED_3, amount: 2 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_SP_1,
    inputs: [{ itemId: ItemId.ITEM_PLANT_SP_1, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_SP_SEED_1, amount: 2 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_SP_2,
    inputs: [{ itemId: ItemId.ITEM_PLANT_SP_2, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_SP_SEED_2, amount: 2 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_SP_3,
    inputs: [{ itemId: ItemId.ITEM_PLANT_SP_3, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_SP_SEED_3, amount: 2 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SEEDCOLLECTOR_PLANT_SP_4,
    inputs: [{ itemId: ItemId.ITEM_PLANT_SP_4, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_PLANT_SP_SEED_4, amount: 2 }],
    facilityId: FacilityId.SEEDCOLLECTOR_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SHAPER_ACTIVITY_XIRANITE_BOTTLE_1,
    inputs: [{ itemId: ItemId.ITEM_XIRANITE_POWDER, amount: 2 }],
    outputs: [{ itemId: ItemId.ITEM_ACTIVITY_XIRANITE_BOTTLE, amount: 1 }],
    facilityId: FacilityId.SHAPER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SHAPER_ACTIVITY_XIRANITE_ENR_BOTTLE_1,
    inputs: [{ itemId: ItemId.ITEM_XIRANITE_ENR_POWDER, amount: 1 }],
    outputs: [{ itemId: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_BOTTLE, amount: 2 }],
    facilityId: FacilityId.SHAPER_1,
    craftingTime: 20,
  },
  {
    id: RecipeId.SHAPER_COPPER_BOTTLE_1,
    inputs: [{ itemId: ItemId.ITEM_COPPER_NUGGET, amount: 2 }],
    outputs: [{ itemId: ItemId.ITEM_COPPER_BOTTLE, amount: 1 }],
    facilityId: FacilityId.SHAPER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SHAPER_COPPER_ENR_BOTTLE_1,
    inputs: [{ itemId: ItemId.ITEM_COPPER_ENR, amount: 2 }],
    outputs: [{ itemId: ItemId.ITEM_COPPER_ENR_BOTTLE, amount: 1 }],
    facilityId: FacilityId.SHAPER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SHAPER_GLASS_BOTTLE_1,
    inputs: [{ itemId: ItemId.ITEM_QUARTZ_GLASS, amount: 2 }],
    outputs: [{ itemId: ItemId.ITEM_GLASS_BOTTLE, amount: 1 }],
    facilityId: FacilityId.SHAPER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SHAPER_GLASS_ENR_BOTTLE_1,
    inputs: [{ itemId: ItemId.ITEM_QUARTZ_ENR, amount: 2 }],
    outputs: [{ itemId: ItemId.ITEM_GLASS_ENR_BOTTLE, amount: 1 }],
    facilityId: FacilityId.SHAPER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SHAPER_IRON_BOTTLE_1,
    inputs: [{ itemId: ItemId.ITEM_IRON_NUGGET, amount: 2 }],
    outputs: [{ itemId: ItemId.ITEM_IRON_BOTTLE, amount: 1 }],
    facilityId: FacilityId.SHAPER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.SHAPER_IRON_ENR_BOTTLE_1,
    inputs: [{ itemId: ItemId.ITEM_IRON_ENR, amount: 2 }],
    outputs: [{ itemId: ItemId.ITEM_IRON_ENR_BOTTLE, amount: 1 }],
    facilityId: FacilityId.SHAPER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.THICKENER_CARBON_ENR_POWDER_1,
    inputs: [
      { itemId: ItemId.ITEM_CARBON_POWDER, amount: 2 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_3, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_CARBON_ENR_POWDER, amount: 1 }],
    facilityId: FacilityId.THICKENER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.THICKENER_CRYSTAL_ENR_POWDER_1,
    inputs: [
      { itemId: ItemId.ITEM_CRYSTAL_POWDER, amount: 2 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_3, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_CRYSTAL_ENR_POWDER, amount: 1 }],
    facilityId: FacilityId.THICKENER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.THICKENER_IRON_ENR_POWDER_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_POWDER, amount: 2 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_3, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_IRON_ENR_POWDER, amount: 1 }],
    facilityId: FacilityId.THICKENER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.THICKENER_ORIGINIUM_ENR_POWDER_1,
    inputs: [
      { itemId: ItemId.ITEM_ORIGINIUM_POWDER, amount: 2 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_3, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_ORIGINIUM_ENR_POWDER, amount: 1 }],
    facilityId: FacilityId.THICKENER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.THICKENER_PLANT_MOSS_ENR_POWDER_1_1,
    inputs: [
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_1, amount: 2 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_3, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_ENR_POWDER_1, amount: 1 }],
    facilityId: FacilityId.THICKENER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.THICKENER_PLANT_MOSS_ENR_POWDER_2_1,
    inputs: [
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_2, amount: 2 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_3, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PLANT_MOSS_ENR_POWDER_2, amount: 1 }],
    facilityId: FacilityId.THICKENER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.THICKENER_QUARTZ_ENR_POWDER_1,
    inputs: [
      { itemId: ItemId.ITEM_QUARTZ_POWDER, amount: 2 },
      { itemId: ItemId.ITEM_PLANT_MOSS_POWDER_3, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_QUARTZ_ENR_POWDER, amount: 1 }],
    facilityId: FacilityId.THICKENER_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.TOOLS_PROC_ACTIVITY_XIRANITE_ENR_HULU_1,
    inputs: [
      { itemId: ItemId.ITEM_FBOTTLE_XIRANENR_GRASS_2, amount: 1 },
      { itemId: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_TOOL, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_HULU, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_ACTIVITY_XIRANITE_ENR_TOOL_1,
    inputs: [
      { itemId: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_CMPT, amount: 1 },
      { itemId: ItemId.ITEM_COPPER_ENR, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_ACTIVITY_XIRANITE_ENR_TOOL, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_ACTIVITY_XIRANITE_HULU_1,
    inputs: [
      { itemId: ItemId.ITEM_ACTIVITY_XIRANITE_BOTTLE, amount: 5 },
      { itemId: ItemId.ITEM_ACTIVITY_XIRANITE_CMPT, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_ACTIVITY_XIRANITE_HULU, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_BATTERY_1_1,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_CMPT, amount: 5 },
      { itemId: ItemId.ITEM_ORIGINIUM_POWDER, amount: 10 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PROC_BATTERY_1, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_BATTERY_2_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_CMPT, amount: 10 },
      { itemId: ItemId.ITEM_ORIGINIUM_POWDER, amount: 15 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PROC_BATTERY_2, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_BATTERY_3_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_ENR_CMPT, amount: 10 },
      { itemId: ItemId.ITEM_ORIGINIUM_ENR_POWDER, amount: 15 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PROC_BATTERY_3, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_BATTERY_4_1,
    inputs: [
      { itemId: ItemId.ITEM_XIRANITE_POWDER, amount: 5 },
      { itemId: ItemId.ITEM_ORIGINIUM_ENR_POWDER, amount: 15 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PROC_BATTERY_4, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_BATTERY_5_1,
    inputs: [
      { itemId: ItemId.ITEM_XIRANITE_POLY, amount: 5 },
      { itemId: ItemId.ITEM_ORIGINIUM_ENR_POWDER, amount: 20 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PROC_BATTERY_5, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_BOMB_1_1,
    inputs: [
      { itemId: ItemId.ITEM_GLASS_CMPT, amount: 5 },
      { itemId: ItemId.ITEM_PLANT_BBFLOWER_POWDER_1, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_PROC_BOMB_1, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_FOOD_4_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_CMPT, amount: 10 },
      { itemId: ItemId.ITEM_FBOTTLE_IRON_GRASS_1, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_FOOD_4, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_FOOD_5_1,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_CMPT, amount: 10 },
      { itemId: ItemId.ITEM_FBOTTLE_COPPER_GRASS_1, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_FOOD_5, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_REC_HP_4_1,
    inputs: [
      { itemId: ItemId.ITEM_IRON_CMPT, amount: 10 },
      { itemId: ItemId.ITEM_FBOTTLE_IRON_GRASS_2, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_REC_HP_4, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.TOOLS_PROC_REC_HP_5_1,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_CMPT, amount: 10 },
      { itemId: ItemId.ITEM_FBOTTLE_COPPER_GRASS_2, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_BOTTLED_REC_HP_5, amount: 1 }],
    facilityId: FacilityId.TOOLS_ASSEBLING_MC_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.WINDER_EQUIP_SCRIPT_1,
    inputs: [
      { itemId: ItemId.ITEM_CRYSTAL_SHELL, amount: 5 },
      { itemId: ItemId.ITEM_QUARTZ_GLASS, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_EQUIP_SCRIPT_1, amount: 1 }],
    facilityId: FacilityId.WINDER_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.WINDER_EQUIP_SCRIPT_2,
    inputs: [
      { itemId: ItemId.ITEM_CRYSTAL_SHELL, amount: 10 },
      { itemId: ItemId.ITEM_IRON_NUGGET, amount: 10 },
    ],
    outputs: [{ itemId: ItemId.ITEM_EQUIP_SCRIPT_2, amount: 1 }],
    facilityId: FacilityId.WINDER_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.WINDER_EQUIP_SCRIPT_3,
    inputs: [
      { itemId: ItemId.ITEM_CRYSTAL_ENR, amount: 10 },
      { itemId: ItemId.ITEM_QUARTZ_ENR, amount: 10 },
    ],
    outputs: [{ itemId: ItemId.ITEM_EQUIP_SCRIPT_3, amount: 1 }],
    facilityId: FacilityId.WINDER_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.WINDER_EQUIP_SCRIPT_4,
    inputs: [
      { itemId: ItemId.ITEM_CRYSTAL_ENR, amount: 10 },
      { itemId: ItemId.ITEM_XIRANITE_POWDER, amount: 10 },
    ],
    outputs: [{ itemId: ItemId.ITEM_EQUIP_SCRIPT_4, amount: 1 }],
    facilityId: FacilityId.WINDER_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.WINDER_EQUIP_SCRIPT_4_1,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_CMPT, amount: 10 },
      { itemId: ItemId.ITEM_XIRANITE_POWDER, amount: 10 },
    ],
    outputs: [{ itemId: ItemId.ITEM_EQUIP_SCRIPT_4_1, amount: 1 }],
    facilityId: FacilityId.WINDER_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.WINDER_EQUIP_SCRIPT_4_2,
    inputs: [
      { itemId: ItemId.ITEM_COPPER_ENR_CMPT, amount: 2 },
      { itemId: ItemId.ITEM_XIRANITE_ENR_POWDER, amount: 2 },
    ],
    outputs: [{ itemId: ItemId.ITEM_EQUIP_SCRIPT_4_2, amount: 1 }],
    facilityId: FacilityId.WINDER_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.XIRANITE_OVEN_MUCK_XIRANITE_1,
    inputs: [
      { itemId: ItemId.ITEM_MUCK_FECES_1, amount: 1 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_MUCK_XIRANITE_1, amount: 1 }],
    facilityId: FacilityId.XIRANITE_OVEN_1,
    craftingTime: 2,
  },
  {
    id: RecipeId.XIRANITE_OVEN_XIRANITE_ENR_POWDER_1,
    inputs: [
      { itemId: ItemId.ITEM_XIRANITE_POWDER, amount: 10 },
      { itemId: ItemId.ITEM_LIQUID_XIRANITE_POLY, amount: 5 },
    ],
    outputs: [{ itemId: ItemId.ITEM_XIRANITE_ENR_POWDER, amount: 1 }],
    facilityId: FacilityId.XIRANITE_OVEN_1,
    craftingTime: 10,
  },
  {
    id: RecipeId.XIRANITE_OVEN_XIRANITE_POWDER_1,
    inputs: [
      { itemId: ItemId.ITEM_CARBON_ENR, amount: 2 },
      { itemId: ItemId.ITEM_LIQUID_WATER, amount: 1 },
    ],
    outputs: [{ itemId: ItemId.ITEM_XIRANITE_POWDER, amount: 1 }],
    facilityId: FacilityId.XIRANITE_OVEN_1,
    craftingTime: 2,
  },
];
